import { throwNotImplemented } from '../../../common'
import { ROTransaction } from '../../../db'
import { Permissions } from '../../authorization'
import { Role, RoleType, RolesRepository } from '../domain/roles'

export const OPERATOR_ROLE_ID = '367b6281a9614345be4a0182dd077331'
export const MODERATOR_ROLE_ID = '39ce5592c6384808a8125b4e99583a65'
export const ADMIN_ROLE_ID = 'f9f1719bf2c94c54b70901ca8f16b5e8'
export const ANONYMOUS_ROLE_ID = '863b53f86aa54d588f98830ff123ee4f'

const ROLES: Role[] = [
  {
    id: ANONYMOUS_ROLE_ID,
    createdAt: new Date('2023-10-23T10:05:46.401Z'),
    name: 'Аноним',
    description: 'Роль анонимных пользователей',
    type: RoleType.ANONYM,
    permissions: [
      Permissions.OPERATOR_SELF_REGISTRATION,
      Permissions.CONTROL_QUESTIONS_VIEW,
      Permissions.MUNICIPAL_ENTITIES_VIEW,
      Permissions.EVENTS_IMPORT,
      Permissions.TOOLS_VIEW,
      Permissions.TOOLS_IMPORT_VIEW,
    ].map(it => it.name),
  },
  {
    id: OPERATOR_ROLE_ID,
    createdAt: new Date('2023-10-23T10:05:46.320Z'),
    name: 'Оператор',
    description: 'Cпециалист в пункте выдачи карт, выполняющий выдачу идентификационных карт в рамках своего МО',
    type: RoleType.OPERATOR,
    permissions: [
      Permissions.CITIZEN_CATEGORIES_VIEW,
      Permissions.ME_CITIZENS_MANAGE,
      Permissions.ME_CITIZENS_VIEW,
      Permissions.CITIZENS_TABLE_EXPORT,
      Permissions.CONTROL_QUESTIONS_VIEW,
      Permissions.EVENTS_EXPORT,
      Permissions.EVENTS_IMPORT,
      Permissions.GLOBAL_SETTINGS_VIEW,
      Permissions.CONSUMPTION_RATES_VIEW,
      Permissions.CONSUMPTION_STANDARDS_VIEW,
      Permissions.ME_CARD_ISSUE_POINTS_ADD,
      Permissions.ME_CARD_ISSUE_POINTS_VIEW,
      Permissions.ME_CARD_ISSUE_POINTS_UPDATE,
      Permissions.ME_SALES_POINTS_VIEW,
      Permissions.MUNICIPAL_ENTITIES_VIEW,
      Permissions.PROFILE_MANAGE,
      Permissions.PROFILE_VIEW,
      Permissions.ROLES_VIEW,
      Permissions.USER_CARD_ISSUE_POINTS_MANAGE,
      Permissions.ME_IDENTITY_CARDS_VIEW,
      Permissions.ME_IDENTITY_CARDS_MANAGE,
      Permissions.TOOLS_VIEW,
      Permissions.TOOLS_EXPORT_VIEW,
      Permissions.TOOLS_IMPORT_VIEW,
      Permissions.ADDRESS_SUGGESTER_SUGGEST,
    ].map(it => it.name),
  },
  {
    id: MODERATOR_ROLE_ID,
    createdAt: new Date('2023-10-23T10:05:46.358Z'),
    name: 'Модератор',
    description: 'Cпециалист, выполняющий функции администрирования системы на уровне муниципального образования',
    type: RoleType.MODERATOR,
    permissions: [
      Permissions.ME_ACTUAL_ISSUE_PRODUCTS_VIEW,
      Permissions.ME_ACTUAL_ISSUE_PRODUCTS_MANAGE,
      Permissions.ACTUAL_ISSUE_PRODUCTS_TABLE_EXPORT,
      Permissions.AUTH_CODES_GENERATE,
      Permissions.CITIZEN_CATEGORIES_COEFFICIENTS_VIEW,
      Permissions.CITIZEN_CATEGORIES_VIEW,
      Permissions.ME_CITIZENS_MANAGE,
      Permissions.ME_CITIZENS_VIEW,
      Permissions.CITIZENS_TABLE_EXPORT,
      Permissions.CONSUMPTION_RATES_VIEW,
      Permissions.CONSUMPTION_RATES_VIEW_STATS,
      Permissions.CONSUMPTION_STANDARDS_VIEW,
      Permissions.CONSUMPTION_STANDARDS_VIEW_STATS,
      Permissions.ME_ISSUANCE_CARDS_STATS_VIEW,
      Permissions.ISSUANCE_CARDS_STATS_TABLE_EXPORT,
      Permissions.USED_CARD_STATS_VIEW,
      Permissions.USED_CARD_STATS_TABLE_EXPORT,
      Permissions.CONTROL_QUESTIONS_VIEW,
      Permissions.EVENTS_EXPORT,
      Permissions.EVENTS_IMPORT,
      Permissions.GLOBAL_SETTINGS_VIEW,
      Permissions.ME_CARD_ISSUE_POINTS_ADD,
      Permissions.ME_CARD_ISSUE_POINTS_DELETE,
      Permissions.ME_CARD_ISSUE_POINTS_UPDATE,
      Permissions.ME_CARD_ISSUE_POINTS_VIEW,
      Permissions.CARD_ISSUE_POINTS_TABLE_EXPORT,
      Permissions.ME_SALES_POINTS_MANAGE,
      Permissions.ME_SALES_POINTS_VIEW,
      Permissions.SALES_POINTS_TABLE_EXPORT,
      Permissions.ME_USERS_MANAGE,
      Permissions.ME_USERS_VIEW,
      Permissions.MUNICIPAL_ENTITIES_VIEW,
      Permissions.PROFILE_MANAGE,
      Permissions.PROFILE_VIEW,
      Permissions.ROLES_VIEW,
      Permissions.USER_CARD_ISSUE_POINTS_MANAGE,
      Permissions.ME_USED_CARDS_STATS_VIEW,
      Permissions.ME_USED_CARDS_STATS_MANAGE,
      Permissions.ME_IDENTITY_CARDS_VIEW,
      Permissions.ME_IDENTITY_CARDS_MANAGE,
      Permissions.TOOLS_VIEW,
      Permissions.TOOLS_EXPORT_VIEW,
      Permissions.TOOLS_IMPORT_VIEW,
      Permissions.TOOLS_EXPORT_OPTS_VIEW,
      Permissions.ADDRESS_SUGGESTER_SUGGEST,
    ].map(it => it.name),
  },
  {
    id: ADMIN_ROLE_ID,
    createdAt: new Date('2023-10-23T10:05:46.381Z'),
    name: 'Администратор',
    description: 'Cпециалист, выполняющий функции администрирования всей системы региона',
    type: RoleType.ADMIN,
    permissions: [
      Permissions.ACTUAL_ISSUE_PRODUCTS_VIEW,
      Permissions.ACTUAL_ISSUE_PRODUCTS_MANAGE,
      Permissions.ACTUAL_ISSUE_PRODUCTS_TABLE_EXPORT,
      Permissions.AUTH_CODES_GENERATE,
      Permissions.CARD_ISSUE_POINTS_MANAGE,
      Permissions.CARD_ISSUE_POINTS_VIEW,
      Permissions.CARD_ISSUE_POINTS_TABLE_EXPORT,
      Permissions.CITIZEN_CATEGORIES_COEFFICIENTS_VIEW,
      Permissions.CITIZEN_CATEGORIES_COEFFICIENTS_MANAGE,
      Permissions.CITIZEN_CATEGORIES_MANAGE,
      Permissions.CITIZEN_CATEGORIES_VIEW,
      Permissions.CITIZENS_MANAGE,
      Permissions.CITIZENS_VIEW,
      Permissions.CITIZENS_TABLE_EXPORT,
      Permissions.CONSUMPTION_RATES_MANAGE,
      Permissions.CONSUMPTION_RATES_VIEW,
      Permissions.CONSUMPTION_RATES_VIEW_STATS,
      Permissions.CONSUMPTION_STANDARDS_VIEW,
      Permissions.CONSUMPTION_STANDARDS_VIEW_STATS,
      Permissions.PRODUCT_PLAN_VIEW,
      Permissions.ISSUANCE_CARDS_STATS_VIEW,
      Permissions.ISSUANCE_CARDS_STATS_TABLE_EXPORT,
      Permissions.USED_CARD_STATS_VIEW,
      Permissions.USED_CARD_STATS_TABLE_EXPORT,
      Permissions.CONTROL_QUESTIONS_VIEW,
      Permissions.EVENTS_EXPORT,
      Permissions.EVENTS_IMPORT,
      Permissions.GLOBAL_SETTINGS_MANAGE,
      Permissions.GLOBAL_SETTINGS_VIEW,
      Permissions.MUNICIPAL_ENTITIES_MANAGE,
      Permissions.MUNICIPAL_ENTITIES_VIEW,
      Permissions.PROFILE_MANAGE,
      Permissions.PROFILE_VIEW,
      Permissions.ROLES_MANAGE,
      Permissions.ROLES_VIEW,
      Permissions.SALES_POINTS_MANAGE,
      Permissions.SALES_POINTS_VIEW,
      Permissions.SALES_POINTS_TABLE_EXPORT,
      Permissions.USER_CARD_ISSUE_POINTS_MANAGE,
      Permissions.USERS_MANAGE,
      Permissions.USERS_VIEW,
      Permissions.USED_CARDS_STATS_VIEW,
      Permissions.USED_CARDS_STATS_MANAGE,
      Permissions.IDENTITY_CARDS_VIEW,
      Permissions.IDENTITY_CARDS_MANAGE,
      Permissions.TOOLS_VIEW,
      Permissions.TOOLS_EXPORT_VIEW,
      Permissions.TOOLS_IMPORT_VIEW,
      Permissions.TOOLS_EXPORT_OPTS_VIEW,
      Permissions.TOOLS_EXPORT_MO_VIEW,
      Permissions.PRODUCT_SUPPLIES_VIEW,
      Permissions.PRODUCT_SUPPLIES_MANAGE,
      Permissions.PRODUCT_SUPPLIES_TABLE_EXPORT,
      Permissions.ADDRESS_SUGGESTER_SUGGEST,
      Permissions.ADDRESS_KLADR_IMPORT,
    ].map(it => it.name),
  },
]

export class PredefinedRolesRepository implements RolesRepository {
  async findAll(): Promise<Role[]> {
    return ROLES
  }

  async findById(tx: ROTransaction, id: string): Promise<Role | undefined> {
    return ROLES.find(r => r.id === id)
  }

  async findByIdNonDeleted(tx: ROTransaction, id: string): Promise<Role | undefined> {
    return ROLES.find(r => r.id === id)
  }

  async findByName(tx: ROTransaction, name: string): Promise<Role | undefined> {
    return ROLES.find(r => r.name === name)
  }

  async save(): Promise<void> {
    throwNotImplemented('<e64b2791>')
  }

  async delete(): Promise<void> {
    throwNotImplemented('<45362d43>')
  }
}
